const getGlobalState = (state, key) => (Array.isArray(state.matchTimeline[key]) ? state.matchTimeline[key].slice(0) : state.matchTimeline[key]);

export const getEventDetails = (state) => getGlobalState(state, 'eventDetails');
export const getMatchTimeline = (state) => getGlobalState(state, 'matchTimeline');

export const getTennisEventDetails = (state) => getGlobalState(state, 'tennisEventDetails');
export const getTennisMatchTimeline = (state) => getGlobalState(state, 'tennisMatchTimeline');

